export default "__VITE_ASSET__Cqp1aFHW__"